import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(5.11vw, 73px) min(9.73vw, 139px);
  align-items: center;
  background-color: #eaf4fb;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  .blue-text {
    line-height: min(5.53vw, 79px);
    color: #095587;
    margin: 0;
  }
  h4 {
    font-size: min(4.2vw, 60px);
    line-height: min(4.2vw, 60px);

    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(1.26vw, 18px);
    text-align: center;
  }
  h5 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(3.5vw, 50px);
    color: #095587;
    text-align: center;
    max-width: min(1036px,72vw);

  }
  button {
    width: min(11.13vw, 159px);
    height: min(2.73vw, 39px);
    font-size: min(1.19vw, 17px);
    border-radius: min(0.42vw, 6px);
    background-color: #095587;
    font-family: "robotoregular";
    color: #fff;
    margin: min(2.03vw, 29px) auto 0;
    border: none;
  }
  @media (max-width: 767px) {
    padding: min(5.11vw, 73px) ;

    h4 {
      line-height: 4vw; 
      margin-bottom: 2.42vw;
    }
    h5 {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
      max-width: 100%;

    }
    button {
      width: 31.7vw;
    height: 7.74vw;
    font-size: 3.38vw;
    border-radius: 6px;
    }
    
  }
`;
const GroupSection = styled.div`
  display: grid;
  grid-template-columns:  1fr 1fr 1fr 1fr;
  grid-gap: min(3.5vw, 50px) min(1.61vw, 23px);
  > div:last-child {
     h6 {
      max-width: min(10.5vw,150px);
     }
    }
  @media (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    gap: 4.84vw;
    justify-content: center;
    > div:last-child {
     h6 {
      max-width: 23.94vw;
     }
    }
  }

`;
const BoxSection = styled.div`
  text-align: center;
  display: grid;
  grid-template-rows: min(8.9vw,117px) min(4.69vw,67px) auto;

  h6 {
    font-size: min(1.26vw, 18px);
    line-height: min(1.47vw, 21px);
    color: #095587;
    font-family: "robotobold";
    margin: min(1.05vw, 15px) auto min(1.19vw, 17px);
    
  }
  p {
    font-size: min(1.19vw, 17px);
    line-height: min(1.61vw, 23px);
    color: #095587;
    font-family: "robotoregular";
    margin: 0;
  }
  img {
    align-self: center;
    margin: 0 auto;
    width: min(8.96vw, 128px);
  }
  @media (max-width: 767px) {
    max-width: 32vw;
    grid-template-rows: 9.55vw 9.55vw auto;

    h6 {
      font-size: 2.94vw;
      line-height: 3.14vw;
      margin-bottom: 2.42vw;
    }
    p {
      font-size: 2.66vw;
      line-height: 2.9vw;
      margin-bottom: 2.42vw;

    }
    
  }
`;
export { Container, Wrapper, GroupSection, BoxSection };
